import { render } from "./detail-admin.vue?vue&type=template&id=73514936&scoped=true"
import script from "./detail-admin.vue?vue&type=script&lang=js"
export * from "./detail-admin.vue?vue&type=script&lang=js"

import "./detail-admin.vue?vue&type=style&index=0&id=73514936&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73514936"]])

export default __exports__